import React from "react";
import { useChat } from "react-live-chat-loader";
import { graphql } from "gatsby";

import * as styles from "./SectionPricingCards.module.less";
import { PrimaryButton } from "components/Buttons";

/**
 * @param {Omit<GatsbyTypes.SectionPricingCardsDataFragment["pricingCards"][0], "triggerIntercom" | "intercomPrefillMessage" | "buttonLink"> & { onButtonClick?: () => void; buttonLink?: string; }} props
 */
function PricingCard({
  title,
  price,
  description,
  buttonText,
  buttonLink,
  onButtonClick,
}) {
  return (
    <div className={styles.pricingCard}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.price}>{price}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.bottomButton}>
        <PrimaryButton
          isContent={true}
          fullWidth={true}
          to={buttonLink}
          title={buttonText}
          onClick={onButtonClick}
        />
      </div>
    </div>
  );
}

/**
 * We use this to define what will be queried for this component
 * This also serves as typings (See `Gatsby.SectionPricingCardsDataFragment` below)
 */
export const SectionPricingCardsDataFragment = graphql`
  fragment SectionPricingCardsData on MarkdownRemarkFrontmatterSections {
    pricingCards {
      buttonText
      price
      title
      description
      buttonLink
      triggerIntercom
      intercomPrefillMessage
    }
    section_id
  }
`;

/**
 * @param {GatsbyTypes.SectionPricingCardsDataFragment} props
 */
export default function SectionPricingCards({ pricingCards = [], section_id }) {
  const [, loadChat] = useChat({ loadWhenIdle: true });

  return (
    <section id={section_id} className={styles.pricingSection}>
      {pricingCards.map(
        (
          { triggerIntercom, intercomPrefillMessage, buttonLink, ...cardProps },
          ind
        ) => {
          const linkProps = triggerIntercom
            ? {
                onButtonClick: () => {
                  loadChat({ open: false });
                  window.Intercom?.(
                    "trackEvent",
                    `interested-${cardProps.title}`
                  );
                  window.Intercom?.("showNewMessage", intercomPrefillMessage);
                },
              }
            : { buttonLink };

          return (
            <PricingCard key={`card-${ind}`} {...cardProps} {...linkProps} />
          );
        }
      )}
    </section>
  );
}
